// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3XNI6","notes":"Notes_notes__3c8I4","note":"Notes_note__1_OAq","markdown":"Notes_markdown__3yIF2"};